import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { addProps /* addIntlProps */ } from 'utils/recompose';
// import messages from './messages';

const formattedCreatedAt = ({ announcement, intl }) => {
  const date = new Date(announcement.createdOn);
  const formattedDate = new Intl.DateTimeFormat(`${intl.locale}`).format(date);
  const options = {
    hour: 'numeric',
    minute: 'numeric',
  };
  const formattedTime = new Intl.DateTimeFormat(
    `${intl.locale}`,
    options,
  ).format(date);

  return `${formattedDate} ${formattedTime}`;
};

const announcementFormatted = ({ announcement }) => {
  return { __html: announcement.message };
};

export default compose(
  injectIntl,
  addProps({ formattedCreatedAt, announcementFormatted }),
);
